import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

import * as Types from './mutations-types';

// 获取默认状态
const getDefaultState = () => {
  return {
    checkProjectId: null,  // 选中项目Id
    checkType: null,       // 选中类型
    checkItem: null,       // 选中项
    checkedParam: null,    // 选中组件
    isHelpShow: null,      // 帮助模块是否显示
    isDetailBack: null     // 是否从详情返回
  };
};

// 初始化状态
const state = getDefaultState();

// 设置状态
const mutations = {
  // 重置状态
  [Types.RESETSTATE](state) {
    Object.assign(state, getDefaultState());
  },
  // 设置选中项目Id
  [Types.SET_CHECKPROJECTID](state, checkProjectId) {
    sessionStorage.setItem('checkProjectId', checkProjectId);
    localStorage.setItem('checkProjectId', checkProjectId);
    state.checkProjectId = checkProjectId;
  },
  // 设置选中类型
  [Types.SET_CHECKTYPE](state, checkType) {
    sessionStorage.setItem('checkType', JSON.stringify(checkType));
    state.checkType = checkType;
  },
  // 设置选中项
  [Types.SET_CHECKITEM](state, checkItem) {
    sessionStorage.setItem('checkItem', JSON.stringify(checkItem));
    state.checkItem = checkItem;
  },
  // 设置选中组件
  [Types.SET_CHECKEDPARAM](state, checkedParam) {
    sessionStorage.setItem('checkedParam', JSON.stringify(checkedParam));
    state.checkedParam = checkedParam;
  },
  // 设置帮助模块是否显示
  [Types.SET_ISHELPSHOW](state, isHelpShow) {
    sessionStorage.setItem('isHelpShow', JSON.stringify(isHelpShow));
    state.isHelpShow = isHelpShow;
  },
  // 设置是否从详情返回
  [Types.SET_ISDETAILBACK](state, isDetailBack) {
    sessionStorage.setItem('isDetailBack', JSON.stringify(isDetailBack));
    state.isDetailBack = isDetailBack;
  }
};

// 获取状态
const getters = {
  // 获取选中项目Id
  getCheckProjectId: state => {
    console.log("----getCheckProjectId", state.checkProjectId ,localStorage.getItem('checkProjectId'),sessionStorage.getItem('checkProjectId'), JSON.parse(sessionStorage.getItem('checkProjectId')));

    return state.checkProjectId || sessionStorage.getItem('checkProjectId')||localStorage.getItem('checkProjectId');
  },
  // 获取选中类型
  getCheckType: state => {
    return state.checkType || JSON.parse(sessionStorage.getItem('checkType'));
  },
  // 获取选中项
  getCheckItem: state => {
    return state.checkItem || JSON.parse(sessionStorage.getItem('checkItem'));
  },
  // 获取选中组件
  getCheckedParam: state => {
    return state.checkedParam || JSON.parse(sessionStorage.getItem('checkedParam'));
  },
  // 获取帮助模块是否显示
  getIsHelpShow: state => {
    return state.isHelpShow || JSON.parse(sessionStorage.getItem('isHelpShow'));
  },
  // 获取是否从详情返回
  getIsDetailBack: state => {
    return state.isDetailBack || JSON.parse(sessionStorage.getItem('isDetailBack'));
  },
};

// actions：设置状态
// 1）修改数据源是通过commit Mutations的方式来实现
// 2）支持执行异步操作
const actions = {};

// 容器是唯一的
export default new Vuex.Store({
  state,
  mutations,
  getters,
  actions,
  strict: true // 只能通过 mutation 来更改状态，mutation不支持异步
});



// WEBPACK FOOTER //
// ./src/store/index.js